/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleCaretLeft = createReactComponent(
  "circle-caret-left",
  "IconCircleCaretLeft",
  [
    ["path", { d: "M9 12l4 -4v8z", key: "svg-0" }],
    ["path", { d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", key: "svg-1" }]
  ]
);

export { IconCircleCaretLeft as default };
//# sourceMappingURL=IconCircleCaretLeft.js.map
